import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { saveFile } from '../helpers/file-download';
import { BaseHttpService } from './base-http.service';
import { EventRequestModel, Permission, AcknowledgementPermission, AnnouncementFeedbackModel, EventRequestChangeStatusType, EventRequesAcknowledgeModel, EventRequesAcknowledgeListModel, RequestBuildingUnitView, CompanyBuildingUnitView, PaginationModel, PagedResult, EventRequestTotals, EventRequestAutocomplete, VenueMeetingItem, RequestCharge } from '../models';
import { AnnouncementRequestsModel, InvoiceFile, GeneralLookup } from '@app/core';

@Injectable()
export class AnnouncementService extends BaseHttpService<any> {

  constructor(private http: HttpClient) {
    super('announcement');
  }

  AddAnnouncementRequest(formData: FormData): Observable<any> {
    return this.http
      .post(this.getApiURI() + '/announcement/AddAnnoncement', formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError)

  }
  UploadInvoice(formData: FormData): Observable<any> {
    return this.http
      .post(this.getApiURI() + '/invoices/SaveInvoice', formData, { headers: new HttpHeaders({ 'RequestWithFiles': 'RequestWithFiles' }) })
      .catch(this.handleError)

  }
  getAnnouncementRequests(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }): Observable<PagedResult<AnnouncementRequestsModel>> {
    return this.http
      .get(this.getApiURI() + '/announcement/GetAnnouncementRequests' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }

  getAnnouncementFeedback(model: { paginationModel: PaginationModel, pendingOnly: boolean, requestStatusId: number, requestNo: string, requestId: number }): Observable<PagedResult<AnnouncementFeedbackModel>> {
    return this.http
      .get(this.getApiURI() + '/announcement/GetAnnouncementFeedback' + `?pagingParameters.pageNumber=${model.paginationModel.pageNumber}&pagingParameters.pageSize=${model.paginationModel.pageSize}&pagingParameters.orderBy=${model.paginationModel.orderBy}&pendingOnly=${model.pendingOnly}&requestStatusId=${model.requestStatusId}&requestNo=${model.requestNo}&requestId=${model.requestId}`)
      .catch(this.handleError)
  }
  approveAnnouncementByTenant(requestId: number): Observable<any> {
    return this.httpClient
      .put(this.getApiURI() + `/announcement/${requestId}/approve-announcement-tenant`, {})
      .catch(this.handleError)
  }
  approveAnnouncementByTSD(requestId: number,isFeedbackNeeded: boolean, feedbackDeadlineDate: Date, sendToAllUsers: boolean ): Observable<any> {
    return this.httpClient
      .put(this.getApiURI() + `/announcement/${requestId}/approve-announcement-TSD`, { isFeedbackNeeded: isFeedbackNeeded, feedbackDeadlineDate: feedbackDeadlineDate, sendToAllUsers: sendToAllUsers })
      .catch(this.handleError)
  }
  rejectAnnouncementByTenant(requestId: number, comments: string): Observable<any> {
    return this.httpClient
      .put(this.uri + `${requestId}/reject-announcement-tenant`, { comments: comments })
      .catch(this.handleError)
  }
  rejectAnnouncementByTSD(requestId: number, comments: string): Observable<any> {
    return this.httpClient
      .put(this.uri + `${requestId}/reject-announcement-TSD`, { comments: comments })
      .catch(this.handleError)
  }
  cancelAnnouncementByTSD(requestId: number, comments: string): Observable<any> {
    return this.httpClient
      .put(this.uri + `${requestId}/cancel-announcement-TSD`, { comments: comments })
      .catch(this.handleError)
  }
  editTargetTenant(requestId: number, targetTenant: string): Observable<AnnouncementRequestsModel> {
    return this.httpClient
      .put(this.uri + `${requestId}/edit-target-tenant`, { targetTenant: targetTenant })
      .catch(this.handleError)
  }
  getTargetTenants(announcementId: number): Observable<number[]> {
    let Params = new HttpParams().set('announcementId', String(announcementId));

    return this.http
      .get(this.getApiURI() + "/announcement/GetTargetTenants", { params: Params })
      .catch(this.handleError)
  }
  pushAnnouncement(requestId: number): Observable<any> {
    return this.httpClient
      .put(this.getApiURI() + `/announcement/${requestId}/push-annuncement`, {})
      .catch(this.handleError)
  }
  getAnnouncementRequestByID(requestId: number): Observable<AnnouncementRequestsModel> {
    return this.http
      .get(this.getApiURI() + `/announcement/GetAnnouncementRequestByID?requestId=${requestId}`)
      .catch(this.handleError)
  }
  editAnnouncementDetails(model: AnnouncementRequestsModel): Observable<any> {
    return this.httpClient
      .put(this.uri + `${model.requestId}/edit-announcement-details`, JSON.stringify(model))
      .catch(this.handleError)
  }
  duplicateAnnouncement(requestId: number): Observable<number> {
    return this.httpClient
      .put(this.getApiURI() + `/announcement/${requestId}/duplicate-annuncement`, {})
      .catch(this.handleError)
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/announcement.service.ts